/**
 * Parameters the kiosk launcher appends to the player URL, captured once at
 * module load.
 *
 * Never read these from the route later: the auth-loss bounce and a device
 * revoke both `router.replace` onto the pairing view without the query string,
 * so by the time anything asks the route, the value may be gone (trap T2). That
 * is how `PROVISIONED_PAIRING_CODE` learned the lesson; this module exists so
 * the next code does not have to, and so it lives outside `main.ts`, which
 * views import from (an import cycle `PairingView` already pays for).
 */

/**
 * The one-time code the Pi's root agent registers and the launcher passes in as
 * `?agentEnrollCode=` (D3). Captured now so the URL contract is fixed; the
 * paired player claims it once the agent exists (plan 03).
 */
export const AGENT_ENROLL_CODE: string | null = new URLSearchParams(window.location.search).get(
  'agentEnrollCode',
);
